export default __webpack_public_path__ + "static/media/R5C_8180.a4fe8d0e.jpg";